import { message } from 'antd';
import api from '../../../services/api';
import { updateOrderItem } from '../reducers';

/**
 * Generic cell save handler for Shopify order items
 */
export const createCellSaveHandler = (dispatch, pagination, fetchOrderItems, forceRefresh = false) => {
    const fieldConfigs = {
        printer: {
            apiField: 'printerId',
            successMessage: 'Printer updated successfully',
            errorMessage: 'Failed to update printer'
        },
        category: {
            apiField: 'categoryId',
            successMessage: 'Category updated successfully',
            errorMessage: 'Failed to update category'
        },
        customizationStatus: {
            apiField: 'customizationStatus',
            successMessage: 'Customization status updated successfully',
            errorMessage: 'Failed to update customization status'
        },
        note: {
            apiField: 'note',
            successMessage: 'Note updated successfully',
            errorMessage: 'Failed to update note'
        },
        internalNote: {
            apiField: 'internalNote',
            successMessage: 'Internal note updated successfully',
            errorMessage: 'Failed to update internal note'
        },
        supporterId: {
            apiField: 'supporterId',
            successMessage: 'Supporter updated successfully',
            errorMessage: 'Failed to update supporter'
        },
        baseCost: {
            apiField: 'baseCost',
            successMessage: 'Base cost updated successfully',
            errorMessage: 'Failed to update base cost'
        },
        fulfillmentStatus: {
            apiField: 'fulfillmentStatus',
            successMessage: 'Fulfillment status updated successfully',
            errorMessage: 'Failed to update fulfillment status'
        },
        fulfillmentId: {
            apiField: 'fulfillmentId',
            successMessage: 'Fulfillment ID updated successfully',
            errorMessage: 'Failed to update fulfillment ID'
        },
        isConfirmShipped: {
            apiField: 'isConfirmShipped',
            successMessage: 'Confirm shipment status updated successfully',
            errorMessage: 'Failed to update confirm shipment status'
        },
        shipmentStatus: {
            apiField: 'shipmentStatus',
            successMessage: 'Shipment status updated successfully',
            errorMessage: 'Failed to update shipment status'
        },
        trackingNumber: {
            apiField: 'trackingNumber',
            successMessage: 'Tracking number updated successfully',
            errorMessage: 'Failed to update tracking number'
        },
        carrier: {
            apiField: 'carrier',
            successMessage: 'Carrier updated successfully',
            errorMessage: 'Failed to update carrier'
        }
    };

    return async (id, column, value) => {
        // Skip if column or value is undefined (user clicked away without selecting)
        if (column === undefined || value === undefined) {
            return;
        }

        const config = fieldConfigs[column];
        
        if (!config) {
            message.error(`Unknown field: ${column}`);
            return;
        }

        try {
            const updateData = { [config.apiField]: value };
            
            const response = await api.patch(`/shopify/orders/items/${id}/fields`, updateData);

            if (response.data.success) {
                // Optimistically update the state without reload
                // supporterId belongs to the parent order, not the line item
                const ORDER_LEVEL_FIELDS = ['supporterId'];
                dispatch(updateOrderItem({
                    id,
                    field: config.apiField,
                    value,
                    orderField: ORDER_LEVEL_FIELDS.includes(config.apiField)
                }));
                message.success(config.successMessage);
                
                // Only force reload if explicitly requested
                if (forceRefresh) {
                    await fetchOrderItems(pagination.current, pagination.pageSize);
                }
                return true;
            } else {
                message.error(response.data.message || config.errorMessage);
                return false;
            }
        } catch (error) {
            console.error(`Error updating ${column}:`, error);
            message.error(config.errorMessage);
            return false;
        }
    };
};
